import { render, staticRenderFns } from "./_depoProgress.vue?vue&type=template&id=070c1f1a&lang=pug&"
import script from "./_depoProgress.vue?vue&type=script&lang=js&"
export * from "./_depoProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports